var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9924 45.4368L28.2148 8.40958L6.01226 45.4368H49.9924ZM31.0875 6.31744L53.1937 43.9034C54.5164 46.1522 52.912 49.0003 50.3225 49.0003H5.67884C3.07666 49.0003 1.47418 46.1271 2.82237 43.8787L25.3599 6.29278C26.6662 4.11425 29.7996 4.12774 31.0875 6.31744ZM28.0007 33.8337C26.7018 33.8337 25.6671 32.8124 25.6672 31.5003V21.0003C25.6672 19.6883 26.7019 18.667 28.0007 18.667C29.2995 18.667 30.3231 19.6883 30.3231 21.0003V31.5003C30.323 32.8124 29.2994 33.8337 28.0007 33.8337ZM30.334 39.667C30.334 40.979 29.2994 42.0003 28.0007 42.0003C26.7019 42.0003 25.6673 40.979 25.6673 39.667C25.6673 38.355 26.7019 37.3337 28.0007 37.3337C29.2994 37.3337 30.334 38.355 30.334 39.667Z",
    fill: "#FFBE2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.ca125bbb618afa5207eb6c38ae0b6e18.svg";
export { ForwardRef as ReactComponent };